import $ from 'jquery';
import useSetEnv from '@global/composable/useSetEnv';
import useNavigation from '@global/composable/useNavigation';
import useFormInputOrder from '@global/composable/useFormInputOrder';

const { setEnv } = useSetEnv();
const { navGlobal, navMobile, subnavDesktop, navDesktop } = useNavigation();

const { formInputOrder } = useFormInputOrder();

window.nowEnv = window.nowEnv || {};

function globalCtrl() {
  setEnv.windowReload();

  navGlobal();

  formInputOrder({
    // input、button 交互focus
    inputArray: ['.footer__newsletter__txt'],
    submitButton: '#btnNewletter',
  });
  formInputOrder({
    // input、button 交互focus
    inputArray: ['#account, #username', '#password', '#captchaTxt, #LoginCode'],
    submitButton: '#btnLogin, #btnShoppingLogin',
  });

  // condition
  if (setEnv.myEquipment()) {
    navMobile();
  } else {
    subnavDesktop();
    navDesktop();
  }
}

export default globalCtrl;
